exports.list = {
    path: '/laporan_stok_barang',
    name: 'laporan_stok_barang', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_stok_barang/List.vue"),
  }